import { createCustomerDisplayConnection } from '../../customerDisplay/connection';
export function connectPublisher(options) {
    if (!this.apiToken || !this.axiosInstance.defaults.baseURL)
        throw new Error('Customer display requires a POS session');
    return createCustomerDisplayConnection(Object.assign(Object.assign({}, options), { token: this.apiToken, baseUrl: this.axiosInstance.defaults.baseURL }));
}
